class VideoHorizontalFlipProcessor {

  constructor(displayAspectRatio) {

    this.canvas = document.createElement('canvas');
    this.canvasContext = this.canvas.getContext('2d');
    this.canvasVideoFrameBuffer = null;

    // this.canvasContext.scale(-0.5, 0.5);

  }

  async load() {

    const CanvasVideoFrameBuffer = (await import('amazon-chime-sdk-js/build/videoframeprocessor/CanvasVideoFrameBuffer.js')).default;

    this.canvasVideoFrameBuffer = new CanvasVideoFrameBuffer(this.canvas);

  }

  async processV2(buffers) {

    const context = this.canvasContext;
    const canvas = buffers[0].asCanvasElement();

    this.canvas.width = canvas.width;
    this.canvas.height = canvas.height;
    context.drawImage(canvas, 0, 0, canvas.width, canvas.height);

    buffers[0] = this.canvasVideoFrameBuffer;

    return buffers;

  }

  async process(buffers) {

    const context = this.canvasContext;
    const canvas = buffers[0].asCanvasElement();

    if (this.canvas.width !== canvas.width || this.canvas.height !== canvas.height) {
      this.canvas.width = canvas.width;
      this.canvas.height = canvas.height;
    }

    context.save();
    context.scale(-1, 1);
    context.translate(-canvas.width, 0);
    context.drawImage(canvas, 0, 0);
    context.restore();

    buffers[0] = this.canvasVideoFrameBuffer;

    return buffers;

  }

}

export default VideoHorizontalFlipProcessor;